import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "column-content"
}
const _hoisted_3 = { id: "persons" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Persons", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "[Person - Add]", -1)
const _hoisted_6 = { class: "mn-person" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "Projects", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", null, "[Project - Add]", -1)
const _hoisted_15 = { class: "mn-project" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Calendars", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", null, "[Calendar - Add]", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }

import { reactive } from 'vue';
import dayjs from 'dayjs';


import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router';
import { useAppContext } from '@/app/_tech'
import { Guid } from '@/lib';
import CalendarComponent from '@/components/Workspaces/CalendarComponent.vue'
import { ResourceCalendar } from '@/logic/workspaces/rcalendar';
import { PersonObligationSpecification } from '@/logic/workspaces/person';
import { watch } from 'vue';
import { PersonRmodel} from '@/app.context/workspace/person.rmodel';
import { dateOrNull } from '@/io/dto/infrastructure.dto.ns'
import { minuteCalc as mc } from '@/logic/_infra/time';
import sys from '@/sys';
//src\io\dto\infrastructure.ts


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsSubview',
  setup(__props) {

const router = useRouter();
const context = useAppContext();

const model: { calendar: ResourceCalendar | null, specifications: Map<Guid, PersonObligationSpecification> } = reactive({ calendar: null, specifications: new Map<Guid, PersonObligationSpecification>() })


const model2: { person: PersonRmodel, calendar: string | null, start: Date | null, end: Date | null, balast: { work: number, offdays: number, offhours: number } }[] = reactive([])



const workspace = computed(() => {

  return context.cursor?.workspace ?? null

})


onMounted(() => setup())

watch(() => context.cursor.workspace, setup)

function setup() {

  const w = workspace.value;

  if (w != null) {
    w.wid

    context.service.obligationSpecifications(w.wid)
      .then(specs => {

        model2.length = 0

        specs.forEach(s => {

          const person = w.person_nid(s.nid)

          const item = { person: person, calendar: s.calendar_name, start: dateOrNull(s.start), end: dateOrNull(s.end), balast: { work: s.balast.work, offdays: s.balast.offdays, offhours: s.balast.offhours } }

          model2.push(item)

          //console.log(item)

        })

      }).catch(sys.exception)


  }

  //if ()

}

function onCalendarClick(id: number) {

  if (id === 0) {

    model.calendar = null;
  }
  else {
    if (workspace.value != null) {

      model.calendar = workspace.value.index.calendars.get(id)!;
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (workspace.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model2, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.person.nid.toString()
              }, [
                _createElementVNode("h2", _hoisted_6, "@" + _toDisplayString(item.person.name), 1),
                _createElementVNode("div", null, [
                  (item.person.captain)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "[Captain]"))
                    : _createCommentVNode("", true),
                  (item.person.subordinate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[Subordinate]"))
                    : _createCommentVNode("", true),
                  (item.person.autonomus)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "[Autonomus]"))
                    : _createCommentVNode("", true),
                  (item.person.user != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "[User]"))
                    : _createCommentVNode("", true)
                ]),
                (!item.person.isGuest())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("p", null, _toDisplayString(item.start != null ? _unref(dayjs)(item.start).format('DD MMM, YYYY') : '') + " - " + _toDisplayString(item.end != null ?
                _unref(dayjs)(item.end).format('DD MMM, YYYY') : ''), 1),
                      (item.calendar != null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Calendar: " + _toDisplayString(item.calendar), 1))
                        : _createCommentVNode("", true),
                      (!item.person.isGuest())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Balast. Work: " + _toDisplayString(_unref(mc).toAproximatedHoursString(item.balast.work)) + " Offdays: " + _toDisplayString(item.balast.offdays) + " Offhours: " + _toDisplayString(_unref(mc).toAproximatedHoursString(item.balast.offhours)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _hoisted_13,
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspace.value.projects(), (p) => {
              return (_openBlock(), _createElementBlock("p", {
                key: p.pid.toString()
              }, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(p.name == '' ? '[icon:home]' : p.name) + " [achive][delete-if]", 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _hoisted_17,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspace.value.calendars(), (c) => {
              return (_openBlock(), _createElementBlock("p", {
                key: c.id.toString()
              }, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (onCalendarClick(c.id)),
                  class: "mn-calendar"
                }, _toDisplayString(c.label) + " [delete-if]", 9, _hoisted_18)
              ]))
            }), 128)),
            (model.calendar != null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(CalendarComponent, {
                    today: new Date(),
                    "first-day-of-week": 1,
                    calendar: model.calendar
                  }, null, 8, ["today", "calendar"]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onCalendarClick(0)))
                  }, "Close")
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19))
  ]))
}
}

})